import React from 'react';
import {
  RedirectToSchoolyearsRoute,
  RedirectToSchoolyearRoute,
} from 'containers/App/AutenticatedApp/SchoolyearsDependentRoutes';
import { Navigate } from 'react-router-dom';

export const RedirectRoutes = {
  path: '*',
  element: <RedirectToSchoolyearsRoute />,
  children: [
    {
      path: 'programmations',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'eleves',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'eleves/import/file',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'emploi-du-temps',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'planner',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'planner/calendar',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'planner/categories',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'budgets',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'pyramides-des-ages',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'trombinoscope',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'registre-appel',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'cahier-journal',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'dashboard',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'carnets-de-notes',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: 'livrets',
      element: <RedirectToSchoolyearRoute />,
    },
    {
      path: '',
      element: <Navigate to={{ pathname: '/dashboard' }} replace />,
    },
    {
      element: <Navigate to={{ pathname: '/' }} replace />,
    },
  ],
};
